import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import Y from '../../y18n'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import TopNavigationAppShell from '../../common/top-navigation-app-shell'
import * as accountActions from '../../store/accounts'
import Styles from '../../common/styles'

const mapStateToProps = state => ({
  accounts: state.accounts,
  locales: state.locales
})

const mapDispatchToProps = dispatch => ({
  accountActions: bindActionCreators(accountActions, dispatch)
})

class LoginPage extends Component {
  state = {
    email: '',
    password: ''
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.accountActions.login(this.state.email, this.state.password).then(res => {
      if (this.props.accounts.passwordTicketId) {
        this.props.history.push(`/set-password/${this.props.accounts.passwordTicketId}?auth=true`)
      } else if (this.props.accounts.profile.tempPassword === 'True') {
        this.props.history.push('/change-password')
      } else if (this.props.accounts.profile.role === 'Admin' || this.props.accounts.profile.role === 'SuperAdmin') {
        this.props.history.push('/admin')
      } else if (this.props.accounts.isAuthenticated) {
        this.props.history.push('/subscriptions')
      }
    })
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

  forgotPassword = () => {
    this.props.history.push('/forgot-password')
  }

  render () {
    const { classes, locales, accounts } = this.props
    return (
      <TopNavigationAppShell
        content={
          <div className={classes.accountContainer}>
            <Link to={'/'}>
              <img src={locales.logo} alt='logo' className={classes.logo} />
            </Link>
            <Paper elevation={3} square style={{ marginTop: '40px', marginBottom: '20px' }}>
              {accounts.loading && <LinearProgress />}
              <div className={classes.content}>
                <div className={classes.textRow}>
                  <Typography variant='title'>{Y`Log in`}</Typography>
                  <Typography variant='body2' className={classes.spacer}>
                    {Y`Login with your email and password to access your subscriptions`}
                  </Typography>
                </div>
                <form onSubmit={e => this.handleSubmit(e)}>
                  <TextField
                    className={classes.spacer}
                    label={Y`Email`}
                    id='email'
                    value={this.state.email}
                    onChange={this.handleChange('email')}
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        root: classes.root,
                        input: classes.input
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                      className: classes.formLabel
                    }}
                    fullWidth
                  />
                  <TextField
                    className={classes.spacer}
                    label={Y`Password`}
                    id='Password'
                    value={this.state.password}
                    onChange={this.handleChange('password')}
                    type='password'
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        root: classes.root,
                        input: classes.input
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                      className: classes.formLabel
                    }}
                    fullWidth
                  />
                  {accounts.loginError &&
                    <div className={classes.textRow}>
                      <Typography variant='body2' className={classes.spacer} style={{ color: 'red' }}>
                        {Y`${accounts.loginError}`}
                      </Typography>
                    </div>}
                  <div className={classes.buttonRow}>
                    <Button
                      style={{ marginRight: '10px' }}
                      tabIndex={-1}
                      onClick={() => this.forgotPassword()}
                    >{Y`Forgot your password?`}</Button>
                    <Button
                      variant='raised'
                      color='primary'
                      style={{ color: '#fff' }}
                      type='submit'
                    >{Y`Log in`}</Button>
                  </div>
                </form>
              </div>
            </Paper>
            <div className={classes.textRow}>
              <Typography variant='body1' className={classes.spacer}>
                {Y`No account yet? Create one`}
                {' '}
                <Link to={'/register'} className={classes.themeLink}>{Y`here`}</Link>
              </Typography>
            </div>
          </div>
        }
        pageName={'Log in'}
      />
    )
  }
}

LoginPage = connect(mapStateToProps, mapDispatchToProps)(LoginPage)
export default withStyles(Styles)(LoginPage)



// WEBPACK FOOTER //
// ./src/pages/account/login.js